module.exports = __webpack_public_path__ + "img/Assets-Award-04.80efcab3.png";